/** @format */

import type { Topic, User } from 'src/types';

export const checkCOntentEditorRole = (user?: Pick<User, 'isEditor' | 'isAdmin'> | null): boolean => {
  return Boolean(user?.isEditor || user?.isAdmin);
};

export const checkAdminRole = (user?: Pick<User, 'isAdmin'> | null): boolean => {
  return Boolean(user?.isAdmin);
};

export function countTopicTreeNodes(nodes?: Topic[] | null): number {
  if (!Array.isArray(nodes)) return 0;
  let total = 0;
  for (const node of nodes) {
    total += 1;
    if (Array.isArray(node?.children) && node.children.length) {
      total += countTopicTreeNodes(node.children);
    }
  }
  return total;
}

export function collectUniqueTagLabels(items?: Array<{ tags?: unknown }> | null): Set<string> {
  const set = new Set<string>();
  if (!Array.isArray(items)) return set;
  for (const item of items) {
    const tags = item?.tags;
    if (!Array.isArray(tags)) continue;
    for (const tag of tags) {
      if (typeof tag !== 'string') continue;
      const trimmed = tag.trim();
      if (!trimmed || /^\+\d+/.test(trimmed)) continue;
      set.add(trimmed);
    }
  }
  return set;
}

const ADMIN_BRAND_LABELS: Record<string, string> = {
  ate: 'ATE',
  vdo: 'VDO',
  continental: 'Continental',
  // Backward-compatible alias (older data may use `conti`)
  conti: 'Continental'
};

export function formatAdminBrandLabel(brand?: string | null): string {
  if (brand == null || brand === '') return '—';
  const key = String(brand).toLowerCase();
  return ADMIN_BRAND_LABELS[key] ?? String(brand);
}

export interface AdminTopicTreeRow {
  key: string;
  id?: Topic['id'];
  name: string;
  displayName: string;
  brand?: Topic['brand'];
  depth: number;
  topic: Topic;
}

export function flattenTopicTreeForAdmin(
  nodes?: Topic[] | null,
  pathPrefix: number[] = []
): AdminTopicTreeRow[] | null {
  if (!Array.isArray(nodes)) return null;
  const rows: AdminTopicTreeRow[] = [];
  for (let i = 0; i < nodes.length; i += 1) {
    const node = nodes[i];
    const name = node?.name ?? '';
    const path = [...pathPrefix, i];
    const rowKey = path.join('-');
    rows.push({
      key: rowKey,
      id: node?.id,
      name,
      displayName: node?.displayName ?? name,
      brand: node?.brand,
      depth: path.length - 1,
      topic: node
    });
    if (Array.isArray(node?.children) && node.children.length) {
      const childRows = flattenTopicTreeForAdmin(node.children, path);
      if (Array.isArray(childRows) && childRows.length) {
        rows.push(...childRows);
      }
    }
  }
  return rows;
}
